import styled from "styled-components";

export const SelectDropdownStyled = styled.div`
width: ${({ widthbox }) => (widthbox ? widthbox : `100px`)};
.label {
  margin-bottom: 4px;
  color: ${({ theme }) => theme.COLORS.GRAY_36};
  font-size: ${({ theme }) => theme.FONT.SIZE.S18};
  font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
}

.control_input {
  border-radius: 12px;
  border: ${({ hideBorder }) => (hideBorder ? `0px` : `1px`)} solid
    ${({ disabled, errors, theme }) =>
    disabled ? `${theme.COLORS.GRAY_37}4D` : errors ? `${theme.COLORS.RED_1}` : `${theme.COLORS.GRAY_41}`};
  background-color: ${({ disabled, theme }) =>
    disabled ? `${theme.COLORS.GRAY_37}4D` : `${theme.COLORS.WHITE_1}`};
  padding: ${({ padding }) => (padding ? padding : `8px 12px`)};
  width: 100%;
  height: ${({ heightBox }) => (heightBox ? heightBox : `40px`)};
  display: flex;
  color: ${({ theme }) => theme.COLORS.GRAY_32};
  font-size: ${({ theme }) => theme.FONT.SIZE.S14};
  font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
  .input {
    flex: 1;
  }
  .Dropdown-arrow-wrapper {
    cursor: pointer;
    display: flex;
    align-items: center;
  }
}
  
.menu_input {
  height: ${({ heightMenu }) => (heightMenu ? heightMenu : `auto`)};
  min-height: ${({ minHeightMenu }) => (minHeightMenu ? minHeightMenu : `unset`)};
  max-height: ${({ maxHeightMenu }) => (maxHeightMenu ? maxHeightMenu : `unset`)};
  background: red;
}

.Dropdown-menu {
  top: ${({ topselect }) => (topselect ? topselect : `100%`)};
  border-radius: ${({ borderRadiusSelect }) =>
    borderRadiusSelect ? borderRadiusSelect : `2px`};
  font-size: ${({ theme }) => theme.FONT.SIZE.S14};
  background: ${({ theme }) => theme.COLORS.WHITE_1};
}
.error_show {
  margin-top: 3px;
  color: ${({ theme }) => theme.COLORS.RED_1};
  font-size: ${({ theme }) => theme.FONT.SIZE.S12};
  font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
}
.input_dropdown_placeholder {
}
`;
